import ProductGroup from '../service/productgroup'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getgroups(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(ProductGroup.getgroups(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getgroup(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(ProductGroup.getgroup(payload), {
        type: 'info',
        success,
        fail
      })
    },
    deletegroup(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(ProductGroup.deletegroup(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addgroup(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(ProductGroup.addgroup(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updategroup(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(ProductGroup.updategroup(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
